import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const IndustrialFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative border-t border-gray-800 bg-black py-8">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
          <div className="text-xs text-gray-600 uppercase tracking-[0.3em] font-mono" style={{ fontFamily: 'var(--font-eurostile)', fontWeight: '900' }}>
            {t('copyright')}
          </div>
          <div className="text-xs text-gray-600 uppercase tracking-[0.3em] font-mono" style={{ fontFamily: 'var(--font-eurostile)', fontWeight: '900' }}>
            {t('allRightsReserved')}
          </div>
        </div>
      </div>
    </footer>
  );
};